/** @jsx h */
/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "Component" }] */
import { h, Component } from 'preact';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import css from '../styles/NavbarButton.module.scss';

const NavbarButton = ({
  children,
  primary,
  secondary,
  alternate,
  venue,
  hideTabletPortraitAndMobile,
  ...restProps
}) => (
  <a
    className={clsx(
      css.NavbarButton,
      primary && css.primary,
      secondary && css.secondary,
      alternate && css.alternate,
      venue && css.venue,
      hideTabletPortraitAndMobile && css.hideTabletPortraitAndMobile,
    )}
    {...restProps}
  >
    {children}
  </a>
);

NavbarButton.propTypes = {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  alternate: PropTypes.bool,
  venue: PropTypes.bool,
  hideTabletPortraitAndMobile: PropTypes.bool,
};

NavbarButton.defaultProps = {
  primary: false,
  secondary: false,
  alternate: false,
  venue: false,
  hideTabletPortraitAndMobile: false,
};

export default NavbarButton;
